module.exports = __webpack_public_path__ + "static/media/home.made.lovely-IG-3.596e213a.PNG";